import { gql } from '@apollo/client'

export const isEmailAvailableQuery = gql`
  query isEmailAvailableQuery($email: String!){
    isEmailAvailable(email: $email){
      is_email_available
    }
}
`
